import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M42.833 43.73l-27.256 7.019a3.604 3.604 0 01-4.384-2.589L2.95 16.15a3.604 3.604 0 012.588-4.384l25.357-6.53 6.49 2.906 8.036 31.204a3.604 3.604 0 01-2.588 4.384z"
        fill="#F2F2F2"
      />
      <Path
        d="M5.796 12.77a2.566 2.566 0 00-1.843 3.122l8.243 32.01a2.566 2.566 0 003.122 1.843l27.256-7.018a2.567 2.567 0 001.843-3.122l-7.91-30.721-5.705-2.554-25.006 6.44z"
        fill="#fff"
      />
      <Path
        d="M37.316 8.307l-4.219 1.087a1.2 1.2 0 01-1.46-.863l-.802-3.115a.075.075 0 01.103-.087l6.39 2.837a.075.075 0 01.044.075.075.075 0 01-.056.066z"
        fill="#F2F2F2"
      />
      <Path
        d="M35.097 35.643l-12.41 3.195a.6.6 0 01-.299-1.16l12.41-3.196a.6.6 0 11.299 1.16zM37.997 36.986l-14.804 3.812a.6.6 0 01-.3-1.161l14.805-3.812a.6.6 0 01.299 1.16z"
        fill="#CCC"
      />
      <Path
        d="M33.777 30.098l-16.48 4.242a1.856 1.856 0 01-2.259-1.334L11.584 19.59a1.857 1.857 0 011.334-2.258l16.48-4.242a1.857 1.857 0 012.26 1.333L35.11 27.84a1.857 1.857 0 01-1.334 2.259z"
        fill="#fff"
      />
      <Path
        d="M33.777 30.098l-16.48 4.242a1.856 1.856 0 01-2.259-1.334L11.584 19.59a1.857 1.857 0 011.334-2.258l16.48-4.242a1.857 1.857 0 012.26 1.333L35.11 27.84a1.857 1.857 0 01-1.334 2.259zM12.972 17.542a1.638 1.638 0 00-1.176 1.993l3.453 13.417a1.638 1.638 0 001.993 1.177l16.48-4.242a1.638 1.638 0 001.178-1.993l-3.454-13.417a1.638 1.638 0 00-1.993-1.177l-16.48 4.242z"
        fill="#E6E6E6"
      />
      <Path
        d="M28.563 17.6l-8.317 2.141a.298.298 0 01-.361-.187.287.287 0 01.202-.364l8.467-2.18c.342.173.252.528.01.59zM28.938 19.06l-8.317 2.14a.298.298 0 01-.361-.187.288.288 0 01.202-.365l8.467-2.179c.342.173.252.528.01.59z"
        fill="#F2F2F2"
      />
      <Path
        d="M19.037 22.494l-2.539.653a.324.324 0 01-.393-.232l-.771-2.996a.323.323 0 01.232-.393l2.539-.653a.323.323 0 01.393.232l.77 2.996a.324.324 0 01-.232.393z"
        fill="#E6E6E6"
      />
      <Path
        d="M29.683 22.052L16.99 25.32a.298.298 0 01-.36-.187.288.288 0 01.201-.365l12.844-3.306c.342.174.252.528.01.59zM30.058 23.512l-12.694 3.267a.298.298 0 01-.36-.187.288.288 0 01.201-.364l12.844-3.306c.342.173.252.527.01.59zM30.435 24.97L17.74 28.238a.298.298 0 01-.36-.187.286.286 0 01.202-.365l12.843-3.306c.342.173.252.528.01.59zM30.81 26.43l-12.694 3.267a.298.298 0 01-.361-.188.286.286 0 01.202-.364L30.8 25.84c.342.173.252.528.01.59zM31.185 27.888l-12.694 3.268a.298.298 0 01-.361-.188.287.287 0 01.202-.364l12.844-3.306c.342.173.252.528.01.59z"
        fill="#F2F2F2"
      />
      <Circle cx={18.5} cy={40.5} r={3.5} fill="#F2F2F2" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 40.008L19.506 39l.491.491L18.99 40.5 20 41.507l-.492.492L18.5 40.99l-1.008 1.008-.491-.492 1.008-1.008L17 39.492l.492-.492 1.007 1.008z"
        fill="#fff"
      />
      <Path
        d="M53.563 54.764H25.418a3.605 3.605 0 01-3.6-3.6V18.109a3.604 3.604 0 013.6-3.6h26.185l5.56 4.432v32.223a3.604 3.604 0 01-3.6 3.6z"
        fill="#E6E6E6"
      />
      <Path
        d="M25.473 15.546a2.566 2.566 0 00-2.564 2.563v33.055a2.566 2.566 0 002.564 2.563h28.145a2.567 2.567 0 002.564-2.563V19.44l-4.887-3.895H25.473z"
        fill="#fff"
      />
      <Path
        d="M57.055 19.084H52.7a1.199 1.199 0 01-1.199-1.2v-3.216a.075.075 0 01.083-.075.075.075 0 01.039.016l5.48 4.341a.076.076 0 01.024.084.075.075 0 01-.07.05zM32.618 24.872c0-.24.196-.436.437-.436h2.4c.24 0 .436.195.436.436v2.946c0 .24-.195.436-.436.436h-2.4a.436.436 0 01-.437-.436v-2.946z"
        fill="#CCC"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.672 22.145H31.418c-1.024 0-1.855.83-1.855 1.855v13.2c0 1.024.83 1.854 1.855 1.854h16.254c1.025 0 1.855-.83 1.855-1.854V24c0-1.024-.83-1.855-1.855-1.855zm-16.254-.327A2.182 2.182 0 0029.236 24v13.2c0 1.205.977 2.182 2.182 2.182h16.254a2.182 2.182 0 002.182-2.182V24a2.182 2.182 0 00-2.182-2.182H31.418z"
        fill="#CCC"
      />
      <Path
        d="M37.2 25.527c0-.18.147-.327.328-.327h8.4a.327.327 0 010 .655h-8.4a.327.327 0 01-.328-.328zM32.618 30.218c0-.18.147-.327.328-.327h12.982a.327.327 0 110 .654H32.946a.327.327 0 01-.328-.327zM32.618 31.746c0-.181.147-.327.328-.327h12.982a.327.327 0 110 .654H32.946a.327.327 0 01-.328-.327zM32.618 33.272c0-.18.147-.327.328-.327h12.982a.327.327 0 110 .655H32.946a.327.327 0 01-.328-.328zM37.2 27.164c0-.18.147-.327.328-.327h5.127a.327.327 0 110 .654h-5.127a.327.327 0 01-.328-.327z"
        fill="#CCC"
      />
      <Circle cx={29.5} cy={45.5} r={3.5} fill="#CCC" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.499 45.008L30.507 44l.491.491L29.99 45.5l1.008 1.008-.491.492-1.008-1.009-1.008 1.008-.491-.491 1.007-1.008L28 44.491l.491-.49 1.008 1.007z"
        fill="#fff"
      />
      <Path
        d="M34.91 44.546c0-.301.244-.546.545-.546h13.09a.546.546 0 010 1.091h-13.09a.546.546 0 01-.546-.545zM34.909 46.618c0-.3.244-.545.545-.545h15.71a.545.545 0 010 1.09h-15.71a.545.545 0 01-.545-.544z"
        fill="#CCC"
      />
      <Circle cx={51} cy={48.5} r={7.5} fill="#FF2E00" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.998 47.024l3.026-3.026 1.475 1.475-3.026 3.026 3.027 3.027L54.025 53l-3.027-3.027-3.025 3.025-1.475-1.475 3.025-3.025-3.024-3.024L47.974 44l3.024 3.024z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
